import './CalendarRow.css'
import { SCHEDULE_EVENTS_TYPES } from '../../../utils/schedule-events-type'

export default function CalendarRow({ day, name, type, auName }) {

   const renderType = () => {
      switch (type) {
         case SCHEDULE_EVENTS_TYPES.lesson:
            return { className: 'CalendarRow--badge-lesson', event: 'Clase' }
         case SCHEDULE_EVENTS_TYPES.exam:
            return { className: 'CalendarRow--badge-exam', event: 'Examen' }
         case SCHEDULE_EVENTS_TYPES.reExam:
            return { className: 'CalendarRow--badge-reExam', event: 'Recuperatorio' }
         case SCHEDULE_EVENTS_TYPES.general:
            return { className: 'CalendarRow--badge-general', event: 'General' }
         case SCHEDULE_EVENTS_TYPES.break:
            return { className: 'CalendarRow--badge-break', event: 'Receso' }
         default: return { className: '', event: '' }
      }
   }

   const typeInfo = renderType();

   return (
      <div className='CalendarRow-card'>
         <div className='CalendarRow-day'>
            <span className='CalendarRow-day__number'>{day}</span>
         </div>
         <div className='CalendarRow-info'>
            <p className='CalendarRow-info__name'>{name}</p>
            {auName && <p className='CalendarRow-info__auName'>{auName}</p>}
            <span className={`CalendarRow-badge ${typeInfo.className}`}>
               {typeInfo.event}
            </span>
         </div>
      </div>
   )
}
